import { IFeedback } from '~/utils/interface/feedback';
import axiosClient from './axiosClient';

const url: string = '/api/feedback';

const feedbackApi = {
  getList(params: IFeedback) {
    return axiosClient.get<any>(url + '/get-list', { params });
  },
};
export default feedbackApi;
